import appMobile from './app-mobile';
import auth from './auth';
import appProps from './app-props';
import users from './users';
import teams from './teams';
import files from './files';
import sidebar from './sidebar';
import flyout from './flyout';
import projects from './projects';
import discussions from './discussions';
import messages from './messages';
import taskGroups from './task-groups';
import tasks from './tasks';
import modal from './modal';
import search from './search';
import docs from './docs';
import milestones from './milestones';
import labels from './labels';
import notifications from './notifications';
import tour from './tour';
import teamChat from './team-chat';
import userActions from './user-actions';
import subscriptions from './subscriptions';
import tokens from './tokens';
import projectTemplates from './project-templates';
import timeTracking from './time-tracking';
import billing from './billing';
import customFields from './custom-fields';
import chatMobile from './chat-mobile';
import filesMobile from './files-mobile';
import modalsMobile from './modals-mobile';
import subteams from './subteams';
import recursionRules from './recursion-rules';
import backgroundTasks from './background-tasks';
import externalAccounts from './external-accounts';
import google from './google';
import userState from './user-state';
import embeds from './embeds';
import folders from './folders';
import connectedAccounts from './connected-accounts';

const reducers = {
    appMobile,
    auth,
    appProps,
    users,
    teams,
    files,
    sidebar,
    flyout,
    projects,
    discussions,
    messages,
    taskGroups,
    tasks,
    modal,
    search,
    docs,
    milestones,
    labels,
    notifications,
    tour,
    teamChat,
    userActions,
    subscriptions,
    tokens,
    projectTemplates,
    timeTracking,
    billing,
    customFields,
    chatMobile,
    filesMobile,
    modalsMobile,
    subteams,
    recursionRules,
    backgroundTasks,
    externalAccounts,
    google,
    userState,
    embeds,
    folders,
    connectedAccounts
};

export default reducers;
